<template>
  <div>
    <form>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
                <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate" />
              </div>
  
              <div class="p-field p-col-12 p-md-2">
                <label for="toDate">To Date</label>
                <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
                <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate" />
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button @click.prevent="searchGrossMarginReport" class="p-button-raised" label="Search"
                  icon="pi pi-search" />
              </div>
            </div>
          </form>
    <div class="p-fluid p-grid">
      <div class="p-col-12 p-md-6">
        <canvas id="gross-margin-bar"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="gross-margin-line"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import DatePicker from 'vue2-datepicker'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import $ from 'jquery'

export default {
  name: 'GrossMarginChart',
  components: {
    DatePicker,
    InputMask,
    Button
  },
  data() {
    return {
      fromDate: null,
      toDate: null,
      grossMarginBarChart: null,
      grossMarginLineChart: null,
      englishDateEnabled: true
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.initializeDates()
  },
  methods: {
    async searchGrossMarginReport() {
      const data = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      try {
        const resp = await this.$store.dispatch('loadGrossMarginGraph', data)
        this.createGrossMarginCharts(resp)
      } catch (error) {
        console.error('Error fetching gross margin data:', error)
      }
    },
    createGrossMarginCharts(data) {
      const chartData = data
      const formattedLabels = chartData.labels
      const datasetsWithColors = chartData.datasets.map(dataset => ({
        ...dataset,
        backgroundColor: dataset.borderColor,
        fill: false
      }))
      const chartOptions = {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'top'
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.6,
            categoryPercentage: 0.75,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Amount'
            }
          }]
        }
      }
      const ctxBar = document.getElementById('gross-margin-bar')
      if (this.grossMarginBarChart) {
        this.grossMarginBarChart.destroy()
      }
      this.grossMarginBarChart = new Chart(ctxBar, {
        type: 'bar',
        data: {
          labels: formattedLabels,
          datasets: datasetsWithColors
        },
        options: {
          ...chartOptions,
          plugins: {
            ...chartOptions.plugins,
            title: {
              display: true,
              text: 'Gross Margin by Category Over Time'
            }
          }
        }
      })
      const ctxLine = document.getElementById('gross-margin-line')
      if (this.grossMarginLineChart) {
        this.grossMarginLineChart.destroy()
      }
      this.grossMarginLineChart = new Chart(ctxLine, {
        type: 'line',
        data: {
          labels: formattedLabels,
          datasets: datasetsWithColors
        },
        options: {
          ...chartOptions,
          plugins: {
            ...chartOptions.plugins,
            title: {
              display: true,
              text: 'Gross Margin Over Time by Category'
            }
          }
        }
      })
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    },
    initializeDates() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
    },
    setEnglishDate() {
      const today = new Date()
      this.fromDate = today.toISOString().slice(0, 10)
      this.toDate = today.toISOString().slice(0, 10)
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  }
}
</script>

<style scoped src="@../../../static/css/purchase.css"></style>



// WEBPACK FOOTER //
// GrossMarginGraph.vue?56fcb164